import DoCdr from "../../../../common/DoCdr/DoCdr";

const DoCdrTable = (props) => {
  const fileHash = props?.row?.original?.file?.hash || "-";
  const fileId = props?.row?.original?.id || "-";
  const severity = props?.row?.original?.severity || "-";
  const fileExt = props?.row?.original?.hashIcon?.fileType || "-";

  return <DoCdr fileHash={fileHash} marginal={"0em"} fileId={fileId} severity={severity} fileExt={fileExt} />;
};

export default DoCdrTable;
